export default __webpack_public_path__ + "static/7-983d8255c1e775bd57233732edf568ca.svg";